module.exports = __webpack_public_path__ + "static/img/K3.8a3fb13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/labels/K3.jpg
// module id = lzXP
// module chunks = 1